<template>
    <div>
        <div class="d-sm-block d-mb-block d-lg-none" v-if="isMobile">
            <v-overlay :value="visible" :absolute="false" opacity="1" scroll-strategy="block" class="overlay-mobile">
                <div class="main-container-mobile">
                    <!-- <img src="@/assets/img/top-left-bg.png" alt="Background" class="background-image-mobile-topleft" />
                    <img src="@/assets/img/top-right-bg.png" alt="Background"
                        class="background-image-mobile-topright" />
                    <img src="@/assets/img/bot-left-bg.png" alt="Background" class="background-image-mobile-botleft" />
                    <img src="@/assets/img/bot-right-bg.png" alt="Background"
                        class="background-image-mobile-botright" /> -->
                    <!-- <img src="@/assets/img/age-confirmation-bg.jpg" alt="Background" class="background-image-mobile" /> -->
                    <!-- <img src="@/assets/img/jameson-logo-age-confirm.jpg" alt="Background" class="background-image-mobile" /> -->
                    <div class="foreground-container-mobile">
                        <div class="first-block-mobile">
                            <img src="@/assets/img/bal-zvuk-logo.svg" alt=""
                                class="jameson-logo-age-confirm-mobile" />
                            <h4 class="title-text-mobile">Введите дату рождения
                                <!-- <pre>рождения</pre> -->
                            </h4>
                            <div class="date-input-container-mobile">
                                <input type="text" maxlength="2" placeholder="дд" @input="validateDay" v-model="day"
                                    class="date-input-mobile" />
                                <input type="text" maxlength="2" placeholder="мм" @input="validateMonth" v-model="month"
                                    class="date-input-mobile" />
                                <input type="text" maxlength="4" placeholder="гггг" @input="validateYear" v-model="year"
                                    class="date-input-mobile" />
                            </div>
                            <button @click="confirmRegistration"
                                class="btn-confirm-mobile mt-10 mb-10">Подтверждаю</button>
                        </div>
                        <!-- <div class="second-block-mobile">
                            <img src="@/assets/img/absolut-age-confirm-mobile-img.png" alt=""
                                class="jameson-age-confirm-mobile" />

                        </div> -->
                    </div>
                </div>
            </v-overlay>
        </div>
        <div class="d-none d-lg-block d-xl-block d-xxl-block" v-else>
            <v-overlay :value="visible" :absolute="false" opacity="1" scroll-strategy="block">
                <div class="main-container">
                    <!-- <img src="@/assets/img/top-right-bg.png" alt="Background" class="background-image-mobile-topright" />
                    <img src="@/assets/img/bot-right-bg.png" alt="Background" class="background-image-mobile-botright" /> -->
                    <!-- <img src="@/assets/img/absolut-age-confirm-bg.jpg" alt="Background" class="background-image" /> -->
                    <div class="foreground-container">
                        <div class="first-block">
                            <!-- <img src="@/assets/img/beefeater-age-confirm-logo.svg" alt=""
                                class="jameson-logo-age-confirm" /> -->
                            <h4 class="title-text">Введите дату рождения</h4>
                            <div class="date-input-container">
                                <input type="text" maxlength="2" placeholder="дд" @input="validateDay" v-model="day"
                                    class="date-input" />
                                <input type="text" maxlength="2" placeholder="мм" @input="validateMonth" v-model="month"
                                    class="date-input" />
                                <input type="text" maxlength="4" placeholder="гггг" @input="validateYear" v-model="year"
                                    class="date-input" />
                            </div>
                            <button @click="confirmRegistration" class="btn-confirm mt-10 mb-10">Подтверждаю</button>
                        </div>
                        <div class="second-block">
                            <img src="@/assets/img/bal-zvuk-logo.svg" alt="" class="jameson-age-confirm" />

                        </div>
                    </div>
                </div>
            </v-overlay>
        </div>
        <v-snackbar v-model="snackbar" timeout="3000" class="btn-contaiener">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
                    Закрыть
                </div>
            </template>
        </v-snackbar>
    </div>
</template>

<style scoped>
/* ----------------------------------------Desktop main styles */
::v-deep .v-overlay__scrim {
    opacity: 1;
    background-color: var(--color-primary-dark) !important;
    border-color: var(--color-primary-dark) !important;
    /* background-image: url('../assets/img/Ball-age-zvuk.jpg');
    background-size: cover;
    background-position: center; */
}

.main-container {
    position: relative;
    /* Родительский контейнер для абсолютного позиционирования */
    height: 100vh;
    /* Высота на весь экран */
    width: 100vw;
    /* Ширина на весь экран */
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    /* Убираем прокрутку */
}
.background-image {
    position: absolute;
    /* Абсолютное позиционирование */
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
    /* Пропорциональное сжатие */
    z-index: 1;
    /* Отправляем изображение на задний план */
}
.foreground-container {
    display: flex;
    align-items: center;
    position: relative;
    /* Текст остается поверх */
    z-index: 1000;
    /* Устанавливаем текст выше изображения */
    color: #CD122D;
    /* Цвет текста */
    font-size: 24px;
    gap: 224px;
}
.first-block {
    text-align: center;
}
.jameson-age-confirm {
  max-width: 100%;     /* чтобы не выходила за контейнер */
  width: 100%;
  height: auto;
}
.title-text {
    margin-bottom: 0px;
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: 30px;
    color: var(--color-white);
    margin-top: 66px;
}
.date-input-container {
    display: flex;
    gap: 10px;
    /* Расстояние между полями */
    margin-bottom: 20px;
    justify-content: center;
    margin-top: 33px;
}
.date-input {
    width: 115px;
    height: 55px;
    border: 2px solid var(--color-white);
    border-radius: 10px;
    background-color: transparent;
    text-align: center;
    font-family: var(--font-family-addition);
    font-weight: 400;
    font-size: var(--font-size-md);
    color: var(--color-white);
    outline: none;
}

.date-input::placeholder {
    color: var(--color-white);
    font-family: var(--font-family-addition);
    font-weight: 400;
    font-size: var(--font-size-md);
    opacity: 1;
}

.date-input:focus {
    border-color: red;
}

/* Убираем стрелочки */
.date-input::-webkit-inner-spin-button,
.date-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.date-input {
    -moz-appearance: textfield;
    /* Для Firefox */
}
.btn-confirm,
.btn-confirm-mobile {
    border-radius: 10px;
    padding: 11px 42px;
    height: 59px;
    color: #020E2D;
    font-family: var(--font-family-cyr);
    font-weight: 400;
    font-size: var(--font-size-md);
    background: var(--color-white);
    cursor: pointer;
    /* box-shadow: 0 4px 0 #04581d; */
    /* легкая тень для объёма */

    /* медленный возврат */
    transition: all 0.4s ease;
}

/* При наведении */
.btn-confirm:hover,
.btn-confirm-mobile:hover {
    background: #f5f5f5;
    /* лёгкое затемнение белого */
    transform: translateY(-2px);
    box-shadow: 0 6px 0 #bcbcbc;

    /* ускоренный вход */
    transition: all 0.15s ease-out;
}

/* При нажатии */
.btn-confirm:active,
.btn-confirm-mobile:active {
    background: #e6e6e6;
    /* чуть темнее для нажатия */
    transform: translateY(2px);
    box-shadow: 0 2px 0 #9e9e9e;
    transition: all 0.1s ease-in;
}


/* ------------------------------------------------Mobile styles */

.overlay-mobile ::v-deep .v-overlay__content {
 position: relative;
  max-height: 100vh; /* ограничиваем высоту окна */
  overflow-y: auto;  /* включаем скролл внутри */
}

.main-container-mobile {
    /* background-image: url('../assets/img/ballantines-age-confirm-bg.jpg');
    background-size: cover;
    background-position: center; */
    position: relative;
    min-height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    /* overflow-y: auto; */
    padding-top: 50px;
}

.foreground-container-mobile {
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1000;
    color: #000;
    font-size: 24px;
    /* gap: 48px; */
    height: 100vh;
    justify-content: flex-start;
}

.first-block-mobile {
    padding-top: 50px;
    text-align: center;
}

.jameson-logo-age-confirm-mobile {
    width: 318.48px;
    height: 251.16px;
}

.title-text-mobile {
    margin-bottom: 0px;
    font-family: var(--font-family-bold);
    color: var(--color-white);
    font-size: 30px;
    line-height: 117%;
    letter-spacing: 0.04em;
    text-align: center;
    font-weight: 700;
    margin-top: 33px;
}

.title-text-mobile pre {
    margin-bottom: 0px;
    font-family: var(--font-family);
    color: var(--color-white);
    font-size: var(--font-size-md);
    line-height: 117%;
    letter-spacing: 0.04em;
    text-align: center;
    font-weight: 400;
}

.date-input-container-mobile {
    display: flex;
    flex-direction: column;
    gap: 25px;
    margin-bottom: 20px;
    justify-content: center;
    margin-top: 33px;
    text-align: center;
    align-items: center;
}

.date-input-mobile {
    width: 325px;
    height: 55px;
    border: 2px solid var(--color-white);
    border-radius: 10px;
    background-color: transparent;
    text-align: center;
    font-family: var(--font-family-addition);
    font-weight: 400;
    font-size: var(--font-size-xs);
    color: var(--color-white);
    outline: none;
}

.date-input-mobile::placeholder {
    color: var(--color-white);
    font-family: var(--font-family-addition);
    font-weight: 400;
    font-size: var(--font-size-xs);
    opacity: 1;
}

.date-input-mobile:focus {
    border-color: red;
}
.btn-confirm-mobile {
    width: 100%;
}

/* ------------------------------Styles для распихивание элементов по 4 углам */

.background-image-mobile-botright {
    position: absolute;
    bottom: -1px;
    right: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;
}

.background-image-mobile-botleft {
    position: absolute;
    bottom: -1px;
    left: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;

}

.background-image-mobile-topright {
    position: absolute;
    top: -1px;
    right: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;
}

.background-image-mobile-topleft {
    position: absolute;
    top: -1px;
    left: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;
}

/* .background-image-mobile {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    z-index: 1;
} */

/*----------------------------------- Snackbar styles */
.snackbar-btn {
    color: var(--Red, #eb5757);
     font-family: var(--font-family);
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    line-height: 1.25rem;
    margin-right: auto;
    padding: 14px 16px;
    text-align: initial;
    cursor: pointer;
}

/* @media (orientation: landscape) {
    .foreground-container-mobile {
        height: auto;
    }
} */
</style>

<script>
import { mapActions } from "vuex";
import { trackAgeGate } from "@/utils/analytics";

export default {


    name: "ConfirmAge1",
    data() {
        return {
            isMobile: window.innerWidth < 1264,
            day: "",
            month: "",
            year: "",
            snackbar: false,
            message: "",
            visible: true,
        };
    },
    methods: {


        ...mapActions(['saveUserAge']),


        handleResize() {
            this.isMobile = window.innerWidth < 1264;
        },
        validateDay() {
            // Убираем все символы, кроме цифр, и ограничиваем длину до 2 символов
            this.day = this.day.replace(/\D/g, "").slice(0, 2);

            // Проверяем, что значение не превышает 31
            if (this.day > 31) {
                this.day = ""; // Очищаем поле, если значение некорректно
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректный день (01-31).";
            }
        },
        validateMonth() {
            // Убираем все символы, кроме цифр, и ограничиваем длину до 2 символов
            this.month = this.month.replace(/\D/g, "").slice(0, 2);

            // Проверяем, что значение не превышает 12
            if (this.month > 12) {
                this.month = ""; // Очищаем поле, если значение некорректно
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректный месяц (01-12).";
            }
        },
        validateYear() {
            // Убираем все символы, кроме цифр, и ограничиваем длину до 4 символов
            this.year = this.year.replace(/\D/g, "").slice(0, 4);
        },
        confirmRegistration() {
            let isValid = true;

            // Проверяем корректность дня
            if (this.day.length !== 2 || this.day > 31 || this.day < 1) {
                this.day = ""; // Очищаем поле
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректный день (01-31).";
                isValid = false;
            }

            // Проверяем корректность месяца
            if (this.month.length !== 2 || this.month > 12 || this.month < 1) {
                this.month = ""; // Очищаем поле
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректный месяц (01-12).";
                isValid = false;
            }

            // Проверяем корректность года
            if (this.year.length !== 4 || this.year < 1900 || this.year > new Date().getFullYear()) {
                this.year = ""; // Очищаем поле
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректный год рождения.";
                isValid = false;
            }

            // Если есть некорректные поля, прекращаем выполнение
            if (!isValid) {
                return;
            }

            // Проверяем, что дата корректна
            const today = new Date();
            const birthDate = new Date(this.year, this.month - 1, this.day);

            if (
                birthDate.getDate() != this.day ||
                birthDate.getMonth() + 1 != this.month ||
                birthDate.getFullYear() != this.year
            ) {
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректную дату.";
                return;
            }

            // Проверяем возраст
            const age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            const dayDiff = today.getDate() - birthDate.getDate();

            if (age > 21 || (age === 21 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)))) {
                console.log(`Дата рождения: ${this.day}.${this.month}.${this.year}`);
                const userAge = `${this.year}-${this.month}-${this.day}`; // строка вида "дд.мм.гггг"

                this.saveUserAge(userAge);
                trackAgeGate(true);
                this.visible = false;
                document.body.style.overflow = "";
                document.body.style.height = "";// Сохраняем в Vuex
                this.$emit("confirmed", userAge);
            } else {
                trackAgeGate(false);
                this.snackbar = true;
                this.message = "Для дальнейшего входа нужно достичь 21 года.";
                return;
            }

            // Собираем данные в переменную userAge

        },


    },
    beforeDestroy() {
        document.body.style.overflow = ""
        document.body.style.height = ""
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
        document.body.style.overflow = "hidden"
        document.body.style.height = "100vh"
        window.addEventListener('resize', this.handleResize);

    },
    computed: {
        // bgStyle() {
        //     return {
        //         backgroundImage: `url(${require('@/assets/img/age-confirmation-bg.png')})`,
        //         backgroundSize: 'contain',
        //         backgroundRepeat: 'no-repeat',
        //         backgroundPosition: 'center',
        //         width: '100vw', // Полная ширина экрана
        //         height: '100vh',
        //     };
        // }
    },

}

</script>